import { createClient } from '@supabase/supabase-js'

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL
const supabaseKey = process.env.REACT_APP_SUPABASE_ANON_KEY
const supabaseServiceKey = process.env.REACT_APP_SUPABASE_SERVICE_ROLE_KEY

// Create single instance of the main client
export const supabase = createClient(supabaseUrl, supabaseKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true
  }
})

// Service role client for admin operations (user creation, etc.)
// Only create when actually needed to avoid multiple client warning
let _supabaseAdmin = null

export const getSupabaseAdmin = () => {
  if (!supabaseServiceKey) {
    console.warn('Service role key not configured')
    return null
  }
  
  if (!_supabaseAdmin) {
    _supabaseAdmin = createClient(supabaseUrl, supabaseServiceKey, {
      auth: {
        autoRefreshToken: false,
        persistSession: false
      }
    })
  }
  
  return _supabaseAdmin
}

// For backward compatibility - use getter property
export const supabaseAdmin = new Proxy({}, {
  get: function(target, prop) {
    const adminClient = getSupabaseAdmin()
    return adminClient ? adminClient[prop] : null
  }
})